import { createRouter, createWebHistory } from "vue-router";
const router = createRouter({ 
    history: createWebHistory(""), 
    routes: [
        { 
            path: "/", 
            name: "dateDifference", 
            component: () => import("../components/DateDifference.vue"),
        },
        { 
            path: "/calculate", 
            name: "dateCalculation", 
            component: () => import("../components/DateCalculation.vue"),
        },
        { 
            path: "/countdown", 
            name: "timeCountdown", 
            component: () => import("../components/TimeCountdown.vue"),
        },
    ], 
}); 
export default router;